import { render, staticRenderFns } from "./gateway.vue?vue&type=template&id=474db604&scoped=true"
import script from "./gateway.vue?vue&type=script&lang=js"
export * from "./gateway.vue?vue&type=script&lang=js"
import style0 from "./gateway.vue?vue&type=style&index=0&id=474db604&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "474db604",
  null
  
)

export default component.exports